import { getSessionCookie } from './sessionId';
import { getSubdomain } from '../utils/helper';
import { ANALYTICS_API_URL } from '../constants';

export const sendData = (cName, cCategory, uType) => {
    const sessionId = getSessionCookie();
    const subDomain = getSubdomain();
    const args = {
        url: window.location.href,
        lang: sessionStorage.getItem('lang')
    }
    const isLoggedIn = JSON.parse(sessionStorage.getItem('loggedIn')).loggedIn
    const rockmanId = sessionStorage.getItem('rockmanId')
    if(isLoggedIn && rockmanId && rockmanId !== 'undefined' && rockmanId.length > 0){
        const data = {
            r: rockmanId,
            portal_session_id: sessionId,
            d: [
                {
                    t: "content_usage",
                    a: {
                        content_name: cName,
                        content_category: cCategory,
                        content_type: "article",
                        usage_type: uType,
                        args: args,
                        product_name: "mobioastro",
                        subdomain: subDomain
                    }
                }
            ]
        };
        // console.log(data)
        var xhr = new XMLHttpRequest();
        xhr.open('POST', ANALYTICS_API_URL, true);
        // xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(data));
    }
    return;
}


// WEBPACK FOOTER //
// ./src/analytics/sendData.js